import { resizeImage } from '~fpu/shared/utils/resize-image';

const PROMO_CONSTS = {
  SOCIAL_MEDIA_IMAGES: [
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-1-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-1.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-1.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Social Media Post - Are You Managing Money.',

      ELEMENT: 'Social Media Images',
      LABEL: 'Are You Managing Money'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-2-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-2.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-2.png',
        300
      ),
      DESCRIPTION: 'Financial Peace Social Media Post - Join My Class.',

      ELEMENT: 'Social Media Images',
      LABEL: 'Join My Class'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-3-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-3.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-3.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Social Media Post - You Work Too Hard To Feel This Broke.',

      ELEMENT: 'Social Media Images',
      LABEL: 'You Work Too Hard To Feel This Broke'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-4-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-4.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-4.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Social Media Post -Join My Financial Peace University Class.',

      ELEMENT: 'Social Media Images',
      LABEL: 'Join My Financial Peace University Class'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-5-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-5.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-5.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Social Media Post - Figure Out Money Alone.',

      ELEMENT: 'Social Media Images',
      LABEL: 'Figure Out Money Alone'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-6-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-6.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-6.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Social Media Post - Leave Money Stress Behind.',

      ELEMENT: 'Social Media Images',
      LABEL: 'Leave Money Stress Behind'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-7-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-7.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-7.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Social Media Post - Break The Paycheck To Paycheck Cycle.',

      ELEMENT: 'Social Media Images',
      LABEL: 'Break The Paycheck To Paycheck Cycle'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-8-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-8.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-8.png',
        300
      ),
      DESCRIPTION: 'Financial Peace Social Media Post - Break The Cycle.',

      ELEMENT: 'Social Media Images',
      LABEL: 'Break The Cycle'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-9-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-9.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-9.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Social Media Post - You Work Too Hard To Feel Broke.',

      ELEMENT: 'Social Media Images',
      LABEL: 'You Work Too Hard To Feel Broke'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-10-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-10.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-10.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Social Media Post - You Were Made For More Than Money Stress.',
      ELEMENT: 'Social Media Images',
      LABEL: 'You Were Made For More Than Money Stress'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-11-vertical.jpg',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-11.jpg'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-11.jpg',
        300
      ),
      DESCRIPTION:
        'Financial Peace Social Media Post - The Borrower Is Servant To The Lender.',

      ELEMENT: 'Social Media Images',
      LABEL: 'The Borrower Is Servant To The Lender'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-12-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-12.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-12.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Social Media Post - You Are Ready To Sign Up.',

      ELEMENT: 'Social Media Images',
      LABEL: 'You Are Ready To Sign Up'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-13-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-13.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-13.png',
        300
      ),
      DESCRIPTION: 'Financial Peace Social Media Post - Beans And Rice.',

      ELEMENT: 'Social Media Images',
      LABEL: 'Beans And Rice'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-14-vertical.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-14.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/social-post-14.png',
        300
      ),
      DESCRIPTION: 'Financial Peace Social Media Post - You Work Too Hard.',

      ELEMENT: 'Social Media Images',
      LABEL: 'You Work Too Hard'
    }
  ],
  SOCIAL_POSTS: {
    SECTIONS: {
      VIRTUAL_CLASS_POSTS: [
        `Ever feel like no matter what you do, you can&apos;t get ahead with money? You&apos;re not alone. You&apos;d be surprised how many people you know are struggling just like you. But it&apos;s time to make a change! Join my <em>Financial Peace University</em> class at <strong>{{time}}</strong> starting on <strong>{{date}}</strong> and learn to pay off debt, save money, and build lasting wealth. Visit <strong>{{unique registration link}}</strong> to sign up!`,
        `If you&apos;re like me (and most people, for that matter), no one ever sat you down and taught you how to handle money. Credit card debt, student loans, arguing with your spouse, stressing over money . . . I thought all of that was normal. But there&apos;s a better way! Join my <em>Financial Peace University</em> class at <strong>{{time}}</strong> starting on <strong>{{date}}</strong> and learn how to pay off debt, save money, and build lasting wealth. Sign up at <strong>{{unique registration link}}</strong>.`,
        `Ever messed up with money? 🙋‍♂️Me too. We all have. But whether your finances are at rock bottom or you just want to do a little better, there&apos;s hope! Join my <em>Financial Peace University</em> class starting on <strong>{{date}}</strong> at <strong>{{time}}</strong> and learn step by step how to budget, pay off debt, and invest for your future! Sign up at <strong>{{unique registration link}}</strong>.`,
        `You work way too hard to feel this broke! Now is the time to take back control of your money, and that starts by taking <em>Financial Peace University</em>. Visit <strong>{{unique registration link}}</strong> to join my class at <strong>{{time}}</strong> starting on <strong>{{date}}</strong>—and start making your money work for you.`,
        `If you&apos;re sick and tired of living paycheck to paycheck, stressing over money, and watching debt steal your hard-earned income, I get it. I&apos;ve been there too. But <em>Financial Peace University</em> helped me turn my finances around, and I want you to know that freedom too! Join my FPU class starting on <strong>{{date}}</strong> at <strong>{{time}}</strong>. Sign up at <strong>{{unique registration link}}</strong>.`,
        `Imagine how much more you could bless others if money weren&apos;t a burden. If you had no debt payments. No money stress. That&apos;s the freedom that God wants for us—and it&apos;s possible! Join my FPU class starting on <strong>{{date}}</strong> at <strong>{{time}}</strong> as we walk through God&apos;s ways of handling money so we can live a debt-free, generous, more abundant life. Sign up at <strong>{{unique registration link}}</strong>.`,
        `If you&apos;re like most Christians, you wish you could honor God more with your finances. But between debt payments and living paycheck to paycheck, you don&apos;t feel like you can. There&apos;s hope! In my FPU class starting on <strong>{{date}}</strong> at <strong>{{time}}</strong>, you&apos;ll learn how to get out of debt and free up your money to give and serve the way God is calling you to. Sign up here: <strong>{{unique registration link}}</strong>.`,
        `As followers of Christ, we believe God owns everything in our lives. And that includes our money. But it&apos;s so easy to get trapped in the world&apos;s ways of handling money: Debt. Out of control spending. Money stress. I&apos;ve been there too—but it doesn&apos;t have to be that way. Join my FPU class starting on <strong>{{date}}</strong> at <strong>{{time}}</strong> and learn God&apos;s ways of handling money. Sign up at <strong>{{unique registration link}}</strong>.`,
        `<strong>PROMPT:</strong> The #1 way to encourage people to sign up for FPU is by sharing the story of how it changed your life! Don&apos;t stress about making it perfect—just make it <em>you</em>. Remember to include your unique class link.`,
        `<strong>PROMPT:</strong> What was your biggest takeaway after going through <em>Financial Peace University</em>? How did it change the way you look at debt and money? Now, share that with your friends and invite them to your next class! Don&apos;t forget to include your unique class link.`
      ],
      IN_PERSON_CLASS_POSTS: [
        `Ever feel like no matter what you do, you can&apos;t get ahead with money? You&apos;re not alone. You&apos;d be surprised how many people you know are struggling just like you. But it&apos;s time to make a change! Join my <em>Financial Peace University</em> class at <strong>{{time}}</strong> starting on <strong>{{date}}</strong> and learn to pay off debt, save money, and build lasting wealth. Visit <strong>{{unique registration link}}</strong> to sign up!`,
        `If you&apos;re like me (and most people, for that matter), no one ever sat you down and taught you how to handle money. Credit card debt, student loans, arguing with your spouse, stressing over money . . . I thought all of that was normal. But there&apos;s a better way! Join my <em>Financial Peace University</em> class at <strong>{{time}}</strong> starting on <strong>{{date}}</strong> and learn how to pay off debt, save money, and build lasting wealth. Sign up at <strong>{{unique registration link}}</strong>.`,
        `Ever messed up with money? 🙋‍♂️Me too. We all have. But whether your finances are at rock bottom or you just want to do a little better, there&apos;s hope! Join my <em>Financial Peace University</em> class starting on <strong>{{date}}</strong> at <strong>{{time}}</strong> and learn step by step how to budget, pay off debt, and invest for your future! Sign up at <strong>{{unique registration link}}</strong>.`,
        `You work way too hard to feel this broke! Now is the time to take back control of your money, and that starts by taking <em>Financial Peace University</em>. Visit <strong>{{unique registration link}}</strong> to join my class at <strong>{{time}}</strong> starting on <strong>{{date}}</strong>—and start making your money work for you.`,
        `If you&apos;re sick and tired of living paycheck to paycheck, stressing over money, and watching debt steal your hard-earned income, I get it. I&apos;ve been there too. But <em>Financial Peace University</em> helped me turn my finances around, and I want you to know that freedom too! Join my FPU class starting on <strong>{{date}}</strong> at <strong>{{time}}</strong>. Sign up at <strong>{{unique registration link}}</strong>.`,
        `Imagine how much more you could bless others if money weren&apos;t a burden. If you had no debt payments. No money stress. That&apos;s the freedom that God wants for us—and it&apos;s possible! Join my FPU class starting on <strong>{{date}}</strong> at <strong>{{time}}</strong> as we walk through God&apos;s ways of handling money so we can live a debt-free, generous, more abundant life. Sign up at <strong>{{unique registration link}}</strong>.`,
        `If you&apos;re like most Christians, you wish you could honor God more with your finances. But between debt payments and living paycheck to paycheck, you don&apos;t feel like you can. There&apos;s hope! In my FPU class starting on <strong>{{date}}</strong> at <strong>{{time}}</strong>, you&apos;ll learn how to get out of debt and free up your money to give and serve the way God is calling you to. Sign up here: <strong>{{unique registration link}}</strong>.`,
        `As followers of Christ, we believe God owns everything in our lives. And that includes our money. But it&apos;s so easy to get trapped in the world&apos;s ways of handling money: Debt. Out of control spending. Money stress. I&apos;ve been there too—but it doesn&apos;t have to be that way. Join my FPU class starting on <strong>{{date}}</strong> at <strong>{{time}}</strong> and learn God&apos;s ways of handling money. Sign up at <strong>{{unique registration link}}</strong>.`,
        `<strong>PROMPT:</strong> The #1 way to encourage people to sign up for FPU is by sharing the story of how it changed your life! Don&apos;t stress about making it perfect—just make it <em>you</em>. Remember to include your unique class link.`,
        `<strong>PROMPT:</strong> What was your biggest takeaway after going through <em>Financial Peace University</em>? How did it change the way you look at debt and money? Now, share that with your friends and invite them to your next class! Don&apos;t forget to include your unique class link.`
      ]
    }
  },
  VIDEOS: [
    {
      ASSET_URL:
        'https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/coordinator/dashboard/assets/RPLUS%20FPU%20TBN%20Ad%20Revised%20for%20B2B_90sec%20(1).mp4',
      THUMBNAIL_URL:
        'https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/coordinator/dashboard/assets/TBN-1min30sec-thumb.png',
      CAPTION: 'Class Promo (1:30)',
      ELEMENT: 'Videos',
      LABEL: 'Class Promo'
    },
    {
      ASSET_URL:
        'https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/coordinator/dashboard/assets/RPLUS%20FPU%20TBN%20Ad%20Revised%20for%20B2B_60sec%20(1).mp4',
      THUMBNAIL_URL:
        'https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/coordinator/dashboard/assets/TBN-1min-thumb.png',
      CAPTION: 'Class Promo (1:00)',
      ELEMENT: 'Videos',
      LABEL: 'RPLUS FPU TBN Ad Revised for B2B_60sec (1)'
    },
    {
      ASSET_URL:
        'https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/coordinator/dashboard/assets/RPLUS%20FPU%20TBN%20Ad%20Revised%20for%20B2B_30sec%20(1)%20(1).mp4',
      THUMBNAIL_URL:
        'https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/coordinator/dashboard/assets/TBN-30-sec-thumb.png',
      CAPTION: 'Class Promo (0:30)',
      ELEMENT: 'Videos',
      LABEL: 'RPLUS FPU TBN Ad Revised for B2B_30sec (1)'
    },
    {
      ASSET_URL:
        'https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/financial-peace/watch/FPU-Lesson1-Sample-480SD.mp4',
      THUMBNAIL_URL:
        'https://cdn.ramseysolutions.net/media/ramsey-plus/financial-peace/coordinator/dashboard/assets/lesson1-sample-thumb.png',
      CAPTION: 'FPU Lesson 1 Sample Video (10:52)',
      ELEMENT: 'Videos',
      LABEL: 'FPU Lesson 1 Sample'
    }
  ],
  ZOOM_BACKGROUNDS: [
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-blank-pattern-03.jpg'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-blank-pattern-03.jpg',
        300
      ),
      DESCRIPTION: 'Financial Peace Zoom Background - Blank with Pattern #3',
      CAPTION: '(Blank with Pattern)',
      ELEMENT: 'Zoom Backgrounds',
      LABEL: 'Blank 3'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-01.jpg'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-01.jpg',
        300
      ),
      DESCRIPTION: 'Financial Peace Zoom Background - Lesson 1',
      CAPTION: '(FPU Lesson 1)',
      ELEMENT: 'Zoom Backgrounds',
      LABEL: 'Lesson 1'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-02.jpg'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-02.jpg',
        300
      ),
      DESCRIPTION: 'Financial Peace Zoom Background - Lesson 2',
      CAPTION: '(FPU Lesson 2)',
      ELEMENT: 'Zoom Backgrounds',
      LABEL: 'Lesson 2'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-03.jpg'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-03.jpg',
        300
      ),
      DESCRIPTION: 'Financial Peace Zoom Background - Lesson 3',
      CAPTION: '(FPU Lesson 3)',
      ELEMENT: 'Zoom Backgrounds',
      LABEL: 'Lesson 3'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-04.jpg'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-04.jpg',
        300
      ),
      DESCRIPTION: 'Financial Peace Zoom Background - Lesson 4',
      CAPTION: '(FPU Lesson 4)',
      ELEMENT: 'Zoom Backgrounds',
      LABEL: 'Lesson 4'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-05.jpg'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-05.jpg',
        300
      ),
      DESCRIPTION: 'Financial Peace Zoom Background - Lesson 5',
      CAPTION: '(FPU Lesson 5)',
      ELEMENT: 'Zoom Backgrounds',
      LABEL: 'Lesson 5'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-06.jpg'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-06.jpg',
        300
      ),
      DESCRIPTION: 'Financial Peace Zoom Background - Lesson 6',
      CAPTION: '(FPU Lesson 6)',
      ELEMENT: 'Zoom Backgrounds',
      LABEL: 'Lesson 6'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-07.jpg'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-07.jpg',
        300
      ),
      DESCRIPTION: 'Financial Peace Zoom Background - Lesson 7',
      CAPTION: '(FPU Lesson 7)',
      ELEMENT: 'Zoom Backgrounds',
      LABEL: 'Lesson 7'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-08.jpg'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-08.jpg',
        300
      ),
      DESCRIPTION: 'Financial Peace Zoom Background - Lesson 8',
      CAPTION: '(FPU Lesson 8)',
      ELEMENT: 'Zoom Backgrounds',
      LABEL: 'Lesson 8'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-09.jpg'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/church/coordinator-tools/download/promo/backgrounds/zoom/fpu-zoom-background-lesson-09.jpg',
        300
      ),
      DESCRIPTION: 'Financial Peace Zoom Background - Lesson 9',
      CAPTION: '(FPU Lesson 9)',
      ELEMENT: 'Zoom Backgrounds',
      LABEL: 'Lesson 9'
    }
  ],
  DIGITAL_SLIDES: [
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/b2b/promo/2023-update/church-slides/fpu-slide-1.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/b2b/promo/2023-update/church-slides/fpu-slide-1.png',
        300
      ),
      DESCRIPTION: 'Presentation Slide',
      CAPTION: 'Blank Slide',
      ELEMENT: 'Digital Slides',
      LABEL: 'Blank'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/b2b/promo/2023-update/church-slides/fpu-slide-2.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/b2b/promo/2023-update/church-slides/fpu-slide-2.png',
        300
      ),
      DESCRIPTION: 'Presentation Slide',
      CAPTION: 'Blank Slide',
      ELEMENT: 'Digital Slides',
      LABEL: 'Blank'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/b2b/promo/2023-update/church-slides/fpu-slide-3.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/b2b/promo/2023-update/church-slides/fpu-slide-3.png',
        300
      ),
      DESCRIPTION: "Presentation Slide - Learn God's ways of handling money.",
      CAPTION: "Learn God's ways of handling money.",
      ELEMENT: 'Digital Slides',
      LABEL: "Learn God's ways of handling money."
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/b2b/promo/2023-update/church-slides/fpu-slide-4.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/b2b/promo/2023-update/church-slides/fpu-slide-4.png',
        300
      ),
      DESCRIPTION: 'Presentation Slide - Never worry about money again.',
      CAPTION: 'Never worry about money again.',
      ELEMENT: 'Digital Slides',
      LABEL: 'Never worry about money again.'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/b2b/promo/2023-update/church-slides/fpu-slide-5.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/daveramsey.com/media/ramsey-plus/b2b/promo/2023-update/church-slides/fpu-slide-5.png',
        300
      ),
      DESCRIPTION: 'Presentation Slide - Join a class today!',
      CAPTION: 'Join a class today!',
      ELEMENT: 'Digital Slides',
      LABEL: 'Join a class today!'
    }
  ],
  PRINTABLE_POSTERS_AND_FLIERS: [
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Way_24_36_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Way_18_24_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Gods_Ways_Tabloid_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Gods_Ways_Tabloid.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Ways_Letter_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Ways_Letter.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Way_24_36_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Way_18_24_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Gods_Ways_Tabloid_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Gods_Ways_Tabloid.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Ways_Letter_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Ways_Letter.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Gods_Ways_Tabloid.png',
        300
      ),
      DESCRIPTION: "Poster - God's ways pf handling money.",

      SIZES: [
        '(24 x 36)',
        '(18 x 24)',
        '(11 x 17 with QR Code)',
        '(11 x 17)',
        '(8.5 x 11 with QR Code)',
        '(8.5 x 11)'
      ],
      ELEMENT: 'Printable Posters and Fliers',
      LABEL: "God's ways of handling money"
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_24_36_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_18_24_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_No_More_Fights_Tabloid_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_No_More_Fights_Tabloid.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_Letter_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_Letter.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_24_36_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_18_24_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_No_More_Fights_Tabloid_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_No_More_Fights_Tabloid.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_Letter_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_Letter.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_No_More_Fights_Tabloid.png',
        300
      ),
      DESCRIPTION: 'Poster - No more fights.',

      SIZES: [
        '(24 x 36)',
        '(18 x 24)',
        '(11 x 17 with QR Code)',
        '(11 x 17)',
        '(8.5 x 11 with QR Code)',
        '(8.5 x 11)'
      ],
      ELEMENT: 'Printable Posters and Fliers',
      LABEL: 'No more fights'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/gods_ways_of_handling_money_24_36_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Way_18_24_QR_v2.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Gods_Way_Tabloid_QR_v2.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Gods_Way_Tabloid_v2.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Ways_Letter_QR_v2.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Ways_Letter_v2.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Way_24_36_QR_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Way_18_24_QR_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Gods_Way_Tabloid_QR_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Gods_Way_Tabloid_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Ways_Letter_QR_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Gods_Ways_Letter_v2.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Gods_Way_Tabloid_v2.png',
        300
      ),
      DESCRIPTION: "Poster - Learn God's ways of handling money.",

      SIZES: [
        '(24 x 36)',
        '(18 x 24)',
        '(11 x 17 with QR Code)',
        '(11 x 17)',
        '(8.5 x 11 with QR Code)',
        '(8.5 x 11)'
      ],
      ELEMENT: 'Printable Posters and Fliers',
      LABEL: "Learn God's ways of handling money"
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_24_36_QR_v2.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_18_24_QR_v2.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_No_More_Fights_Tabloid_QR_v2.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_No_More_Fights_Tabloid_v2.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_Letter_QR_v2.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_Letter_v2.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_24_36_QR_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_18_24_QR_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_No_More_Fights_Tabloid_QR_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_No_More_Fights_Tabloid_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_Letter_QR_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/No_More_Fights_Letter_v2.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_No_More_Fights_Tabloid_v2.png',
        300
      ),
      DESCRIPTION: 'Poster - No more money fights.',

      SIZES: [
        '(24 x 36)',
        '(18 x 24)',
        '(11 x 17 with QR Code)',
        '(11 x 17)',
        '(8.5 x 11 with QR Code)',
        '(8.5 x 11)'
      ],
      ELEMENT: 'Printable Posters and Fliers',
      LABEL: 'No more money fights'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Sign_Up_24_36_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Sign_Up_18_24_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Sign_Up_Tabloid_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Sign_Up_Tabloid.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Sign_Up_Letter_QR_v2.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Sign_Up_Letter.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Sign_Up_24_36_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Sign_Up_18_24_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Sign_Up_Tabloid_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Sign_Up_Tabloid.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Sign_Up_Letter_QR_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Sign_Up_Letter.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Sign_Up_Tabloid.png',
        300
      ),
      DESCRIPTION: 'Poster - Sign up for Financial Peace.',

      SIZES: [
        '(24 x 36)',
        '(18 x 24)',
        '(11 x 17 with QR Code)',
        '(11 x 17)',
        '(8.5 x 11 with QR Code)',
        '(8.5 x 11)'
      ],
      ELEMENT: 'Printable Posters and Fliers',
      LABEL: 'Sign up for Financial Peace'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Freedom_24_36_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Freedom_18_24_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Freedom_Tabloid_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Freedom_Tabloid_v2.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Freedom_Letter_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Freedom_Letter.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Freedom_24_36_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Freedom_18_24_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Freedom_Tabloid_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Freedom_Tabloid_v2.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Freedom_Letter_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Freedom_Letter.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Freedom_Tabloid_v2.png',
        300
      ),
      DESCRIPTION: 'Poster - Debt is not your destiny.',

      SIZES: [
        '(24 x 36)',
        '(18 x 24)',
        '(11 x 17 with QR Code)',
        '(11 x 17)',
        '(8.5 x 11 with QR Code)',
        '(8.5 x 11)'
      ],
      ELEMENT: 'Printable Posters and Fliers',
      LABEL: 'Debt is not your destiny'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Free_Up_Your_24_36_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Free_Up_Your_Money_18_24_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Free_Up_Your_Money_Tabloid_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Free_Up_Your_Money_Tabloid.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Free_Up_Your_Money_Letter_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Free_Up_Your_Money_Letter.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Free_Up_Your_24_36_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Free_Up_Your_Money_18_24_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Free_Up_Your_Money_Tabloid_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Free_Up_Your_Money_Tabloid.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Free_Up_Your_Money_Letter_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Free_Up_Your_Money_Letter.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Free_Up_Your_Money_Tabloid.png',
        300
      ),
      DESCRIPTION: 'Poster - Free up your money.',

      SIZES: [
        '(24 x 36)',
        '(18 x 24)',
        '(11 x 17 with QR Code)',
        '(11 x 17)',
        '(8.5 x 11 with QR Code)',
        '(8.5 x 11)'
      ],
      ELEMENT: 'Printable Posters and Fliers',
      LABEL: 'Free up your money'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Starts_Here_24_36_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Starts_Here_18_24_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Starts_Here_Tabloid_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Starts_Here_Tabloid.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Starts_Here_Letter_QR.pdf',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Starts_Here_Letter.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Starts_Here_24_36_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Starts_Here_18_24_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Starts_Here_Tabloid_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Starts_Here_Tabloid.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Starts_Here_Letter_QR.png',
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/Starts_Here_Letter.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/11x17_Starts_Here_Tabloid.png',
        300
      ),
      DESCRIPTION: 'Poster - Financial Peace starts here.',

      SIZES: [
        '(24 x 36)',
        '(18 x 24)',
        '(11 x 17 with QR Code)',
        '(11 x 17)',
        '(8.5 x 11 with QR Code)',
        '(8.5 x 11)'
      ],
      ELEMENT: 'Printable Posters and Fliers',
      LABEL: 'Financial Peace starts here'
    }
  ],
  DESCRIPTIONS_FOR_BULLETINS_AND_ANNOUNCEMENTS: [
    `If you've ever felt like you just can't get in control of your money, you're not alone. You'd be surprised how many people you know are struggling just like you. But it's time for your struggle to end—starting today. Join my virtual <em>Financial Peace University</em> class starting on <strong>{{date}}</strong> and learn how you can pay off debt, save more money, and build wealth. Visit <strong>{{unique registration link}}</strong> to sign up!`,
    `This culture is <em>designed</em> to take you down. Credit cards, car loans, student loans . . . they'll keep you paying way too much money for way too long. But there's one way out of the mess of debt, and it starts right here with <em>you</em>. You can change your future today by joining my virtual <em>Financial Peace University</em> class. You'll learn to pay off debt fast, save more money, and build lasting wealth. Class starts on <strong>{{date}}</strong>, so sign up today at <strong>{{unique registration link}}</strong>!`,
    `You work way too hard to be this broke! <em>Now</em> is the time to take back control of your money, and that starts by taking <em>Financial Peace University</em>. Visit <strong>{{unique registration link}}</strong> to join my virtual class starting <strong>{{date}}</strong>, and start making your money work for <em>you</em>.`,
    `Have you been looking for a way to finally get on top of your money? This. Is. Your. Time. And you don't even have to leave your home to do it! Just visit <strong>{{unique registration link}}</strong> to join my virtual <em>Financial Peace University</em> class starting on <strong>{{date}}</strong>. Make today the day you decide to own <em>your</em> money—not the other way around. You've got this!`,
    `According to a study by the Ramsey Solutions research team, 40% of Americans say their financial situation has caused them to lose sleep in the past month. If that's you, it's time to make a change. Take the first step and take control of your finances by signing up for my virtual <em>Financial Peace University</em> class at <strong>{{unique registration link}}</strong>. Class (and better sleep) starts on <strong>{{date}}</strong>. Ready? Let's do this.`
  ],
  EMAIL_HEADERS: [
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-1@2x.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-1@2x.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Email Header - Ramsey Solutions Financial Peace University.',

      ELEMENT: 'Email Headers',
      LABEL: 'Ramsey Solutions Financial Peace University'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-2@2x.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-2@2x.png',
        300
      ),
      DESCRIPTION: 'Financial Peace Email Header - Ramsey Financial Peace U.',

      ELEMENT: 'Email Headers',
      LABEL: 'Ramsey Financial Peace U'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-3@2x.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-3@2x.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Email Header - Ramsey Financial Peace University.',

      ELEMENT: 'Email Headers',
      LABEL: 'Ramsey Financial Peace University'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-4@2x.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-4@2x.png',
        300
      ),
      DESCRIPTION: 'Financial Peace Email Header - Financial Peace University.',

      ELEMENT: 'Email Headers',
      LABEL: 'Financial Peace University'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-5@2x.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-5@2x.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Email Header - Join A Class Financial Peace University.',

      ELEMENT: 'Email Headers',
      LABEL: 'Join A Class Financial Peace University'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-6@2x.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/email-financialpeace-6@2x.png',
        300
      ),
      DESCRIPTION:
        'Financial Peace Email Header - Financial Peace Starts Here.',

      ELEMENT: 'Email Headers',
      LABEL: 'Financial Peace Starts Here'
    }
  ],
  OUTDOOR_BANNERS: [
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_ClassGraduates_blank.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_ClassGraduates-EXAMPLE.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_ClassGraduates-EXAMPLE.png',
        300
      ),
      DESCRIPTION: 'Banner - Class Graduates.',

      SIZES: ['(6 x 3) EXAMPLE'],
      ELEMENT: 'Outdoor Banners',
      LABEL: 'Class Graduates'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_ClassGraduates_QR_Code_blank.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_ClassGraduates_QR_Code-EXAMPLE.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_ClassGraduates_QR_Code-EXAMPLE.png',
        300
      ),
      DESCRIPTION: 'Banner - Class Graduates QR.',

      SIZES: ['(6 x 3) EXAMPLE WITH QR CODE'],
      ELEMENT: 'Outdoor Banners',
      LABEL: 'Class Graduates QR'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_DaveRamsey_blank.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_DaveRamsey-EXAMPLE.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_DaveRamsey-EXAMPLE.png',
        300
      ),
      DESCRIPTION: 'Banner - Dave Ramsey.',

      SIZES: ['(6 x 3) EXAMPLE'],
      ELEMENT: 'Outdoor Banners',
      LABEL: 'Dave Ramsey'
    },
    {
      ASSET_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_DaveRamsey_QR_Code_blank.pdf'
      ],
      PREVIEW_URLS: [
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_DaveRamsey_QR_Code-EXAMPLE.png'
      ],
      THUMBNAIL_URL: resizeImage(
        'https://cdn.ramseysolutions.net/media/fpu/coordinator/promo-assests-2025/FPU_Coordinator_Banner_6x3_DaveRamsey_QR_Code-EXAMPLE.png',
        300
      ),
      DESCRIPTION: 'Banner - Dave Ramsey QR.',

      SIZES: ['(6 x 3) EXAMPLE WITH QR CODE'],
      ELEMENT: 'Outdoor Banners',
      LABEL: 'Dave Ramsey QR'
    }
  ]
};

export const {
  SOCIAL_MEDIA_IMAGES,
  SOCIAL_POSTS,
  VIDEOS,
  ZOOM_BACKGROUNDS,
  DIGITAL_SLIDES,
  PRINTABLE_POSTERS_AND_FLIERS,
  EMAIL_HEADERS,
  OUTDOOR_BANNERS,
  DESCRIPTIONS_FOR_BULLETINS_AND_ANNOUNCEMENTS
} = PROMO_CONSTS;

export default PROMO_CONSTS;
